<template>
  <div class="report-coverage">

    <div class="report-header mb-4">
      <h3 class="report-title">Cobertura de Inspeções por Unidade</h3>
      <p class="report-subtitle">
        Acompanhe a frequência das inspeções por unidade, período e modelo de vistoria.
      </p>
    </div>

    <b-row class="mb-4">
      <b-col cols="12" md="6" lg="3" class="mb-3">
        <div class="summary-card">
          <div class="summary-card__label">Unidades cadastradas</div>
          <div class="summary-card__value">{{ totalUnits }}</div>
        </div>
      </b-col>

      <b-col cols="12" md="6" lg="3" class="mb-3">
        <div class="summary-card">
          <div class="summary-card__label">Unidades inspecionadas</div>
          <div class="summary-card__value">{{ inspectedUnits }}</div>
        </div>
      </b-col>

      <b-col cols="12" md="6" lg="3" class="mb-3">
        <div class="summary-card">
          <div class="summary-card__label">Cobertura média</div>
          <div class="summary-card__value">{{ averageCoverage }}%</div>
        </div>
      </b-col>

      <b-col cols="12" md="6" lg="3" class="mb-3">
        <div class="summary-card">
          <div class="summary-card__label">Total de inspeções</div>
          <div class="summary-card__value">{{ totalInspections }}</div>
        </div>
      </b-col>
    </b-row>

    <b-card class="mb-4 coverage-chart-card">
      <div class="section-title mb-3">Evolução da Cobertura no Período</div>

      <apexchart
          type="line"
          height="320"
          :options="coverageChartOptions"
          :series="coverageChartSeries"
      />

    </b-card>

    <b-card class="coverage-table-card">
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
        <div class="section-title mb-2 mb-md-0">Cobertura por Unidade</div>

        <div class="coverage-legend">
          <span class="legend-item">
            <span class="legend-dot legend-dot--ok"></span>
            Com inspeção
          </span>

          <span class="legend-item">
            <span class="legend-dot legend-dot--none"></span>
            Sem inspeção
          </span>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered coverage-table">
          <thead>
          <tr>
            <th class="text-left">Unidade</th>
            <th class="text-center">Última inspeção</th>
            <th class="text-left">Modelo da última vistoria</th>

            <th
                v-for="month in months"
                :key="'head-' + month.key"
                class="text-center"
            >
              {{ month.label }}
            </th>

            <th class="text-center">Total</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="row in rows" :key="row.id">
            <td class="font-weight-bold">{{ row.unit }}</td>
            <td class="text-center">{{ row.lastInspection }}</td>
            <td>{{ row.lastModel }}</td>

            <td
                v-for="month in months"
                :key="row.id + '-' + month.key"
                class="text-center coverage-cell"
                :class="getCoverageCellClass(row.months[month.key])"
            >
              {{ row.months[month.key] }}
            </td>

            <td class="text-center font-weight-bold total-cell">
              {{ getRowTotal(row) }}
            </td>
          </tr>
          </tbody>

          <tfoot>
          <tr>
            <th colspan="3" class="text-right">Unidades inspecionadas no mês</th>

            <th
                v-for="month in months"
                :key="'units-' + month.key"
                class="text-center footer-highlight"
            >
              {{ getInspectedUnitsByMonth(month.key) }}
            </th>

            <th class="text-center footer-highlight">
              {{ inspectedUnits }}
            </th>
          </tr>

          <tr>
            <th colspan="3" class="text-right">Cobertura (%)</th>

            <th
                v-for="month in months"
                :key="'coverage-' + month.key"
                class="text-center footer-highlight"
            >
              {{ getCoverageByMonth(month.key) }}%
            </th>

            <th class="text-center footer-highlight">
              {{ averageCoverage }}%
            </th>
          </tr>

          <tr>
            <th colspan="3" class="text-right">Qtd. de inspeções</th>

            <th
                v-for="month in months"
                :key="'qty-' + month.key"
                class="text-center footer-highlight"
            >
              {{ getInspectionCountByMonth(month.key) }}
            </th>

            <th class="text-center footer-highlight">
              {{ totalInspections }}
            </th>
          </tr>
          </tfoot>
        </table>
      </div>
    </b-card>

  </div>
</template>

<script>

export default {
  name: 'InspectionCoverageReport',

  data() {
    return {
      coverageChart: null,
      coverageChartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },

        stroke: {
          width: [0, 3]
        },

        colors: ['#4338F2', '#2196F3'],

        dataLabels: {
          enabled: false
        },

        plotOptions: {
          bar: {
            borderRadius: 6,
            columnWidth: '45%'
          }
        },

        xaxis: {
          categories: []
        },

        yaxis: [
          {
            title: {
              text: 'Qtd. de inspeções'
            }
          },
          {
            opposite: true,
            max: 100,
            title: {
              text: 'Cobertura (%)'
            }
          }
        ],

        tooltip: {
          shared: true,
          intersect: false
        }
      },

      coverageChartSeries: [],

      months: [
        { key: 'jan', label: 'Jan' },
        { key: 'fev', label: 'Fev' },
        { key: 'mar', label: 'Mar' },
        { key: 'abr', label: 'Abr' },
        { key: 'mai', label: 'Mai' },
        { key: 'jun', label: 'Jun' }
      ],

      rows: [
        {
          id: 1,
          unit: 'Escola Shirley Guio',
          lastInspection: '12/01/2026',
          lastModel: 'Civil',
          months: { jan: 1, fev: 0, mar: 0, abr: 2, mai: 1, jun: 0 }
        },
        {
          id: 2,
          unit: 'Escola Central',
          lastInspection: '20/03/2026',
          lastModel: 'Elétrica',
          months: { jan: 2, fev: 1, mar: 1, abr: 1, mai: 0, jun: 1 }
        },
        {
          id: 3,
          unit: 'Hospital Norte',
          lastInspection: '08/06/2026',
          lastModel: 'Geral',
          months: { jan: 0, fev: 0, mar: 1, abr: 0, mai: 0, jun: 1 }
        },
        {
          id: 4,
          unit: 'Bloco Administrativo',
          lastInspection: '15/05/2026',
          lastModel: 'Civil',
          months: { jan: 1, fev: 1, mar: 0, abr: 0, mai: 1, jun: 0 }
        },
        {
          id: 5,
          unit: 'Unidade Leste',
          lastInspection: '03/06/2026',
          lastModel: 'Elétrica',
          months: { jan: 0, fev: 1, mar: 0, abr: 1, mai: 0, jun: 1 }
        }
      ],
    }
  },

  computed: {
    totalUnits() {
      return this.rows.length
    },

    inspectedUnits() {
      return this.rows.filter(row => this.getRowTotal(row) > 0).length
    },

    totalInspections() {
      return this.rows.reduce((sum, row) => sum + this.getRowTotal(row), 0)
    },

    averageCoverage() {
      if (!this.months.length || !this.totalUnits) {
        return 0
      }

      const totalCoverage = this.months.reduce((sum, month) => {
        return sum + this.getCoverageByMonth(month.key)
      }, 0)

      return Math.round(totalCoverage / this.months.length)
    },


  },

  mounted() {
    this.updateCoverageChart()
  },

  beforeDestroy() {
    if (this.coverageChart) {
      this.coverageChart.destroy()
      this.coverageChart = null
    }
  },

  methods: {

    updateCoverageChart() {

      const months = this.months.map(m => m.label)

      const inspectionCounts = this.months.map(m =>
          this.getInspectionCountByMonth(m.key)
      )

      const coverage = this.months.map(m =>
          this.getCoverageByMonth(m.key)
      )

      this.coverageChartOptions.xaxis.categories = months

      this.coverageChartSeries = [
        {
          name: 'Qtd. de inspeções',
          type: 'column',
          data: inspectionCounts
        },
        {
          name: 'Cobertura (%)',
          type: 'line',
          data: coverage
        }
      ]

    },

    getRowTotal(row) {
      return this.months.reduce((sum, month) => {
        return sum + Number(row.months[month.key] || 0)
      }, 0)
    },

    getInspectedUnitsByMonth(monthKey) {
      return this.rows.filter(row => Number(row.months[monthKey] || 0) > 0).length
    },

    getInspectionCountByMonth(monthKey) {
      return this.rows.reduce((sum, row) => {
        return sum + Number(row.months[monthKey] || 0)
      }, 0)
    },

    getCoverageByMonth(monthKey) {
      if (!this.totalUnits) {
        return 0
      }

      return Math.round((this.getInspectedUnitsByMonth(monthKey) / this.totalUnits) * 100)
    },

    getCoverageCellClass(value) {
      if (Number(value) > 0) {
        return 'coverage-cell--ok'
      }

      return 'coverage-cell--none'
    },


  }
}
</script>

<style scoped>
.report-coverage {
  padding: 8px 4px 20px 4px;
}

.report-title {
  font-size: 24px;
  font-weight: 700;
  color: #32415f;
  margin-bottom: 6px;
}

.report-subtitle {
  font-size: 14px;
  color: #76839d;
  margin-bottom: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #32415f;
}

.summary-card {
  background: #fff;
  border: 1px solid #e3e9f4;
  border-radius: 14px;
  padding: 18px;
  height: 100%;
}

.summary-card__label {
  font-size: 13px;
  color: #7b879c;
  margin-bottom: 8px;
}

.summary-card__value {
  font-size: 28px;
  font-weight: 700;
  color: #3f35f0;
  line-height: 1;
}

.coverage-chart-card,
.coverage-table-card {
  border: 1px solid #e3e9f4;
  border-radius: 16px;
}

.coverage-chart-card canvas {
  width: 100% !important;
  min-height: 320px;
}

.coverage-legend {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #6f7d95;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-dot {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  display: inline-block;
}

.legend-dot--ok {
  background: #e8eeff;
  border: 1px solid #8aa2ff;
}

.legend-dot--none {
  background: #fff1f1;
  border: 1px solid #f3b1b1;
}

.coverage-table {
  margin-bottom: 0;
  background: #fff;
}

.coverage-table thead th {
  background: #f7f9fd;
  color: #52627f;
  font-size: 13px;
  font-weight: 700;
  vertical-align: middle;
  white-space: nowrap;
}

.coverage-table tbody td,
.coverage-table tfoot th,
.coverage-table tfoot td {
  vertical-align: middle;
}

.coverage-cell {
  font-weight: 700;
  min-width: 58px;
}

.coverage-cell--ok {
  background: #edf3ff;
  color: #2d4fd3;
}

.coverage-cell--none {
  background: #fff2f2;
  color: #d35b5b;
}

.total-cell {
  background: #f8faff;
  color: #2f3f5d;
}

.footer-highlight {
  background: #f5f7fc;
  color: #32415f;
  font-weight: 700;
}

@media (max-width: 991px) {
  .report-title {
    font-size: 20px;
  }

  .summary-card__value {
    font-size: 24px;
  }
}
</style>